import type {
    IconBlock,
    ImageBlock,
    VideoBlock,
    VideoEmbedBlock,
    HorizontalLineBlock,
    SlateBlock,
    EmbedBlock,
} from '@atlas/renderer';

export default function isVoidBlock(element: SlateBlock): element is VoidBlock {
    return (VOID_BLOCK_TYPES as Array<SlateBlock['type']>).includes(element.type);
}

// #region Helpers

const VOID_BLOCK_TYPES: Array<VoidBlock['type']> = [
    'icon',
    'image',
    'video',
    'video-embed',
    'embed',
    'horizontal-line',
];

// #endregion

// #region Types

export type VoidBlock = IconBlock | ImageBlock | VideoBlock | VideoEmbedBlock | EmbedBlock | HorizontalLineBlock;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isVoidBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
